import React from 'react'
import styled from 'styled-components/macro'

export default props => <div>DASHBOARD</div>
